import React from 'react';

const ProfileEdit = () => {
    return (
        <div>
            
        </div>
    );
};

export default ProfileEdit;